<div style="margin: 20px; min-height: 500px; min-width: 500px;">
  <h1>Role użytkownika</h1>
  <div *ngFor="let role of roles" style="margin-bottom: 20px;">
    <p-checkbox name="selectedRoles" [(ngModel)]="selectedRoles" [value]="role.id" label="{{role.name}}"></p-checkbox>
  </div>
  <div>
    <span style="float: right;">
      <p-button class="button" (click)="cancel()" label="Zamknij"></p-button>
      <p-button class="button" (click)="setRoles()" label="Nadaj role"></p-button>
    </span>
  </div>
</div>
